module.exports = __webpack_public_path__ + "static/media/squirrel3.b25d2cfb.jpg";